import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowTriangleRight"><Path d="M4.5 19.5V4.5L19.5 12L4.5 19.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleRight;
